"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var formatting_1 = require("lets-trade-utils/lib/utils/formatting");
var react_2 = require("react");
function TitleCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small text-default-foreground font-bold" }, { children: cellValue }));
}
function StatusCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small capitalize text-default-foreground" }, { children: cellValue }));
}
function CategoriesCellView(_a) {
    var cellValue = _a.cellValue;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-wrap gap-1" }, { children: cellValue === null || cellValue === void 0 ? void 0 : cellValue.map(function (cat) { return ((0, jsx_runtime_1.jsx)(react_1.Chip, __assign({ size: "sm", variant: "flat", className: "text-xs" }, { children: cat }), cat)); }) })));
}
function TagsCellView(_a) {
    var cellValue = _a.cellValue;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-wrap gap-1" }, { children: cellValue === null || cellValue === void 0 ? void 0 : cellValue.map(function (tag) { return ((0, jsx_runtime_1.jsx)(react_1.Chip, __assign({ size: "sm", variant: "flat", className: "text-xs" }, { children: tag }), tag)); }) })));
}
function FeaturedCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small text-default-foreground" }, { children: cellValue ? "Yes" : "No" }));
}
function PublishDateCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small text-default-foreground" }, { children: (0, formatting_1.formatDateTime)(new Date(cellValue)) }));
}
function useRenderCellViews() {
    var renderCellViews = (0, react_2.useCallback)(function (cellValue, record) {
        return [
            {
                key: "title",
                content: (0, jsx_runtime_1.jsx)(TitleCellView, { cellValue: cellValue }),
            },
            {
                key: "status",
                content: (0, jsx_runtime_1.jsx)(StatusCellView, { cellValue: cellValue }),
            },
            {
                key: "categories",
                content: (0, jsx_runtime_1.jsx)(CategoriesCellView, { cellValue: cellValue }),
            },
            {
                key: "tags",
                content: (0, jsx_runtime_1.jsx)(TagsCellView, { cellValue: cellValue }),
            },
            {
                key: "featured",
                content: (0, jsx_runtime_1.jsx)(FeaturedCellView, { cellValue: cellValue }),
            },
            {
                key: "publish_date",
                content: (0, jsx_runtime_1.jsx)(PublishDateCellView, { cellValue: cellValue }),
            },
        ];
    }, []);
    return {
        renderCellViews: renderCellViews,
    };
}
exports.useRenderCellViews = useRenderCellViews;
